import React from 'react';
import styled from 'styled-components';
import { theme } from '../styles/theme';

const TabsContainer = styled.div`
  display: flex;
  border-bottom: 1px solid ${theme.colors.border};
  margin-bottom: ${theme.spacing[6]};
`;

const TabButton = styled.button<{ $isActive: boolean }>`
  display: flex;
  align-items: center;
  gap: ${theme.spacing[2]};
  padding: ${theme.spacing[4]} ${theme.spacing[6]};
  border: none;
  background: transparent;
  color: ${({ $isActive }) => $isActive ? theme.colors.primary[600] : theme.colors.textSecondary};
  font-weight: ${({ $isActive }) => $isActive ? theme.typography.fontWeight.semibold : theme.typography.fontWeight.medium};
  font-size: ${theme.typography.fontSize.sm};
  cursor: pointer;
  transition: all ${theme.transitions.base};
  border-bottom: 2px solid transparent;
  border-bottom-color: ${({ $isActive }) => $isActive ? theme.colors.primary[500] : 'transparent'};
  
  &:hover {
    color: ${theme.colors.primary[600]};
    background: ${theme.colors.primary[50]};
  }
  
  &:focus {
    outline: none;
    box-shadow: ${theme.shadows.focusRing};
  }

  svg {
    width: 18px;
    height: 18px;
  }
`;

export interface Tab {
  id: string;
  label: string;
  icon: React.ReactNode;
  badge?: string;
}

interface TabNavigationProps {
  tabs: Tab[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
}

const TabNavigation: React.FC<TabNavigationProps> = ({ 
  tabs, 
  activeTab, 
  onTabChange 
}) => {
  return (
    <TabsContainer>
      {tabs.map((tab) => (
        <TabButton
          key={tab.id}
          $isActive={activeTab === tab.id}
          onClick={() => onTabChange(tab.id)}
        >
          {tab.icon}
          {tab.label}
          {tab.badge && (
            <span style={{
              fontSize: '10px',
              background: theme.colors.primary[100],
              color: theme.colors.primary[700],
              padding: '2px 6px',
              borderRadius: '8px',
              fontWeight: 500
            }}>
              {tab.badge}
            </span>
          )}
        </TabButton>
      ))}
    </TabsContainer>
  );
};

export default TabNavigation;